import styled from "styled-components";

export const IdNumContainer = styled.div`
  margin: 5px 5px 0 0;
  padding: 5px;
`;
